import {
    WifiOff, RefreshCw,
    Crown,
    ClipboardList, Mail, Search, FileText, Mic, CheckCircle2, XCircle,
} from 'lucide-react'

/* ── Хелперы ── */
export function daysUntil(dateStr) {
    if (!dateStr) return Infinity
    const now = new Date(); now.setHours(0, 0, 0, 0)
    const target = new Date(dateStr); target.setHours(0, 0, 0, 0)
    return Math.ceil((target - now) / 86400000)
}
export function formatDate(d) {
    if (!d) return '—'
    const [y, m, day] = d.split('-')
    return `${day}.${m}.${y}`
}
export function shortName(name) {
    const parts = (name || '').split(' ')
    if (parts.length >= 3) return `${parts[0]} ${parts[1][0]}.${parts[2][0]}.`
    if (parts.length === 2) return `${parts[0]} ${parts[1][0]}.`
    return name || '?'
}

/* ── Widget ── */
export function Widget({ title, badge, badgeColor, children, style }) {
    return (
        <div className="card card--elevated animate-rise-in" style={style}>
            <div className="card__header">
                <span className="card__title">{title}</span>
                {badge && (
                    <span
                        style={{
                            padding: '3px 10px',
                            borderRadius: 'var(--radius-full)',
                            background: badgeColor || 'var(--color-accent-bg)',
                            color: badgeColor ? 'var(--color-text-on-fill)' : 'var(--color-accent)',
                            boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.15)',
                        }}
                        className='text-xs fw-600'>{badge}</span>
                )}
            </div>
            <div className="card__body">{children}</div>
        </div>
    )
}

/* ── Offline Banner ── */
export function OfflineBanner({ onRefresh, loading }) {
    return (
        <div
            style={{
                padding: '10px 16px',
                background: 'var(--color-warning-bg)',
                border: '1px solid color-mix(in srgb, var(--color-warning) 20%, transparent)'
            }}
            className='flex items-center gap-10 radius-8 mb-16 text-sm color-warning'>
            <WifiOff size={14} />
            <span className="flex-1 fw-600">Бэкенд недоступен — данные из кэша или отсутствуют</span>
            <button
                onClick={onRefresh}
                disabled={loading}
                style={{
                    padding: '4px 12px',
                    border: '1px solid color-mix(in srgb, var(--color-warning) 30%, transparent)',
                    background: 'transparent'
                }}
                className='radius-6 color-warning cursor-pointer text-xs fw-600 flex items-center gap-4'>
                <RefreshCw size={12} className={loading ? 'spin' : ''} /> Повторить
            </button>
        </div>
    )
}

/* ── Этапы Pipeline ── */
export const PIPELINE_STAGES = [
    { key: 'new', label: 'Новый', Icon: ClipboardList, color: 'var(--color-text-muted)', ring: 'color-mix(in srgb, var(--color-text-muted) 20%, transparent)' },
    { key: 'first_contact', label: 'Первый контакт', Icon: Mail, color: 'var(--color-info)', ring: 'color-mix(in srgb, var(--color-info) 20%, transparent)' },
    { key: 'screening', label: 'Скрининг', Icon: Search, color: 'var(--color-info)', ring: 'color-mix(in srgb, var(--color-info) 20%, transparent)' },
    { key: 'testing', label: 'Тестирование', Icon: FileText, color: 'var(--color-warning)', ring: 'color-mix(in srgb, var(--color-warning) 20%, transparent)' },
    { key: 'interview', label: 'Собес. с внутр. заказчиком', Icon: Mic, color: 'var(--color-danger)', ring: 'color-mix(in srgb, var(--color-danger) 20%, transparent)' },
    { key: 'owner_interview', label: 'Собес. с собственниками', Icon: Crown, color: 'var(--color-purple)', ring: 'color-mix(in srgb, var(--color-purple) 20%, transparent)' },
    { key: 'offer', label: 'Оффер', Icon: CheckCircle2, color: 'var(--color-success)', ring: 'color-mix(in srgb, var(--color-success) 20%, transparent)' },
    { key: 'rejected', label: 'Отклонён', Icon: XCircle, color: 'var(--color-danger)', ring: 'color-mix(in srgb, var(--color-danger) 20%, transparent)' },
]
